import axios, { getAuthProvider } from "@utils/axios-instance";
import plainAxios from "axios";
import { API_URL } from "@/config";
import { TLoginPayload, TLoginResponse, TRefreshTokenResponse } from "@models/auth.model";

export const login = async (data: TLoginPayload): Promise<TLoginResponse> => {
  const response = await axios.post("/login", data);
  return response.data;
};

type SignupFields = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
};

export type CodeDetails = {
  companyName: string;
  email: string;
};

export const signup = async (data: SignupFields): Promise<TLoginResponse> => {
  const response = await axios.post("/signup", { ...data });
  return response.data;
};

export const getSignUpCodeDeails = async (code: string): Promise<CodeDetails> => {
  const response = await axios.get(`/infobycode?code=${code}`);
  return response.data;
};

export const forgotPassword = async (email: string): Promise<string> => {
  const response = await axios.post("/auth/forgot-password", { email });
  return response.data.message;
};

export const resetPassword = async (password: string, token: string): Promise<void> => {
  const response = await axios.post(`/auth/reset-password?token=${token}`, { password });
  return response.data;
};

export const acceptInvite = async (data: {
  code: string;
  password: string;
  firstName: string;
  lastName: string;
}): Promise<TLoginResponse> => {
  const { code, ...payload } = data;
  const response = await axios.post(`/auth/accept-invite?code=${code}`, payload);
  return response.data;
};

export const refreshAccessToken = async (refreshToken: string): Promise<TRefreshTokenResponse> => {
  const authProvider = getAuthProvider();
  const response = await plainAxios.post(`${API_URL}/auth/refresh`, {
    RefreshToken: refreshToken,
    ...(authProvider ? { AuthProvider: authProvider } : {}),
  });
  return response.data;
};

export default {
  login,
  signup,
  acceptInvite,
  refreshAccessToken,
};
